// | Wrapper around Set providing Decode and Encode instances. For use
// | primarily in transport types.
// |
// | The set is serialized as an array of elements in unspecified order.
import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  return x => $0(Data$dMap$dInternal.keys(x));
})();
const $$Set = x => x;
const udecodeSet = dictOrd => dictDecode => Unscramble.decodeSet(dictDecode)(dictOrd);
const showSet = dictShow => Data$dSet.showSet(dictShow);
const semigroupSet = dictOrd => (
  {
    append: (() => {
      const compare = dictOrd.compare;
      return m1 => m2 => Data$dMap$dInternal.unsafeUnionWith(compare, Data$dFunction.const, m1, m2);
    })()
  }
);
const ordSet = dictOrd => Data$dSet.ordSet(dictOrd);
const newtypeSet = {Coercible0: () => {}};
const monoidSet = dictOrd => Data$dSet.monoidSet(dictOrd);
const foldableSet = Data$dSet.foldableSet;
const eqSet = dictEq => {
  const eq = Data$dMap$dInternal.eqMap(dictEq)(Data$dEq.eqUnit).eq;
  return {eq: v => v1 => eq(v)(v1)};
};
const encodeSet = dictEncode => (
  {
    encode: (() => {
      const $0 = Data$dFunctor.arrayMap(dictEncode.encode);
      return x => $0(toUnfoldable(x));
    })()
  }
);
const decodeSet = dictOrd => {
  const fromFoldable1 = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(dictOrd)(a)()(m))(Data$dMap$dInternal.Leaf);
  return dictDecode => (
    {
      decode: (() => {
        const $0 = Foreign$dGeneric$dClass.arrayDecode(dictDecode).decode;
        return x => {
          const $1 = $0(x);
          if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
          if ($1.tag === "Right") { return Data$dEither.$Either("Right", fromFoldable1($1._1)); }
          $runtime.fail();
        };
      })()
    }
  );
};
export {$$Set as Set, decodeSet, encodeSet, eqSet, foldableSet, monoidSet, newtypeSet, ordSet, semigroupSet, showSet, toUnfoldable, udecodeSet};
